import { InjectionToken } from '@angular/core';
import { Localization } from '../models';

export const LOCALIZATIONS: InjectionToken<Localization[]> = new InjectionToken<Localization>('@cue/localizations');
